export default __webpack_public_path__ + "static/media/analytics.5fde8ba5.svg";